import { AxiosResponse } from 'axios';


class ApiError extends Error {
    response: AxiosResponse;

    constructor(response: AxiosResponse, message: string) {
        super(message);
        this.response = response;
    }
}

export class NotAuthorizedError extends ApiError {
    constructor(response: AxiosResponse) {
        super(response, 'notAuthorized');
    }
}

export class ForbiddenError extends ApiError {
    constructor(response: AxiosResponse) {
        super(response, 'forbidden');
    }
}

export class NotFoundError extends ApiError {
    constructor(response: AxiosResponse) {
        super(response, 'notFound');
    }
}

export class UnknownError extends ApiError {
    constructor(response: AxiosResponse) {
        super(response, 'unknown');
    }
}
